import React, {useEffect, useState, useRef} from "react";
import styles from './InputWithValidation.module.scss';

import Tooltip from "../Tooltip/Tooltip";
import {FiInfo} from "react-icons/fi";
import _ from "lodash";
import {$validate} from "../../../helpers/formValidator";
import {AiOutlineEye, AiOutlineEyeInvisible} from "react-icons/ai";

const InputWithValidation = (props) => {
    const [value, setValue] = useState('');
    const [errors, setErrors] = useState([]);
    const [typingTimeout, setTypingTimeout] = useState(0)
    const [focused, setFocused] = useState(false)
    const onChangeRef = useRef(null);

    const onFocus = () => {
        // console.log('onfocus')
        setFocused(true)
        setTouched(true)
    }
    const onBlur = () => setFocused(false)
    const [touched, setTouched] = useState(false)
    const [type, setType] = useState(props.type)

    useEffect(() => {
        // console.log('in input, onmount: ', props.value)
        validate(value);
    }, []);

    useEffect(() => {
        // console.log('input (value change):', value)
        validate(value);
    }, [value]);


    useEffect(() => {
        validate(value);
    }, [props.validateNow]);


    useEffect(() => {
        // console.log('in input >>>> ',props.name , props.value)
        if (props && props.value && props.value.value) {
            setValue(props.value.value)
        }
    }, [props.value]);

    useEffect(() => {
        if (props.touched) {
            setTouched(true);
            validate(value);
        } else {
            setTouched(false)
        }
    }, [props.touched]);

    useEffect(() => {
        onChangeRef.current = props.onChange;
    }, [props]);

    const onChange = (e) => {
        if(onChangeRef.current) {
            onChangeRef.current(e);
        }
    }

    function changeHandler(e) {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setValue(e.target.value);

        if (props.validations) {
            validate(e.target.value, e);
        } else {
            onChange({
                value: value,
                errors: []
            }, e)
        }
    }

    function validate(value, e) {
        let errorsArr = $validate(value, props.validations);
        setErrors(errorsArr);
        setTypingTimeout(setTimeout(function () {
            onChange({
                value: value,
                errors: errorsArr
            }, e)
        }, props.delay ? props.delay : 0))
        
    }

    return (
        <div className={styles.inputContainer} style={props.styles}>
            <div className={styles.container}>
                <input
                    name={props.autoComplete ? props.name : null} //turning off autocomplete by removing name
                    disabled={props.disabled}
                    className={`${'alma-input'} ${styles.select} ${errors && errors.length && touched ? styles.inputError : ''}`}
                    // style={props.styles}
                    type={type}
                    value={value}
                    placeholder={props.placeholder}
                    onChange={(e) => changeHandler(e)}
                    onFocus={(e) => {
                        onFocus();
                    }}
                    onBlur={onBlur}
                />

                <div className={styles.iconsContainer}>
                    {
                        props.type === 'password' ?
                            <div className={styles.flexCenter}>
                                {type === 'password' ?
                                    <AiOutlineEye className={styles.infoIcon} onClick={() => setType('text')}/>
                                    :
                                    <AiOutlineEyeInvisible className={styles.infoIcon}
                                                           onClick={() => setType('password')}/>
                                }
                            </div>
                            :
                            null
                    }
                    {
                        props.tooltip ?
                            <span className={styles.tooltip}>
                                <Tooltip content={props.tooltip}>
                                    <FiInfo className={styles.infoIcon}/>
                                </Tooltip>
                            </span>
                            :
                            null
                    }
                </div>

            </div>
            {
                props.validations && props.validations.length ?
                    <div className={`${styles.errorsContainerContainer}`}>
                        {touched ?
                            <div>
                                {
                                    focused && errors && errors.length ?
                                        <div className={`${styles.errorsContainer} ${(styles.errorsContainerFocus)}`}>
                                            {errors.map(function (v, k) {
                                                return (
                                                    <div className={`${styles.error}`} key={`val-err-${k}`}>{v}</div>
                                                )
                                            })}
                                        </div>
                                        :
                                        <div>
                                            <div className={`${styles.error}`}>{errors[0]}</div>
                                        </div>
                                }
                            </div>
                            :
                            null
                        }
                    </div>
                    :
                    null
            }
        </div>
    )
}

InputWithValidation.defaultProps = {
    delay: 0,   //ms
    validations: [],
    name: 'noice-input-field',
    disabled: false,
    className: 'alma-input',
    type: 'text',
    value: '',
    placeholder: '',
    tooltip: '',
    styles: null,
    onChange: () => console.log('Please provide an "onChange={(data) => fieldChangeHandler(data)" prop to InputWithValidation component'),
    autoComplete: true,
}

export default InputWithValidation;
